import { useAuth } from "@apps-common/contexts"
import { usePortalFirebaseUser } from "./usePortalFirebaseUser"

export interface ICombinedUserDetails {
    firstName?: string | null
    fullName?: string | null
    displayName?: string | null
    profileImage?: string | null
}

export const useCombinedUserDetails = (): ICombinedUserDetails => {
    const { user } = useAuth()
    const portalUser = usePortalFirebaseUser()

    return {
        firstName: portalUser?.firstName,
        fullName: portalUser?.fullName,
        displayName: user?.displayName,
        profileImage: user?.photoURL
    }
}